<!--交账入口-->
<template>
  <!--三级路由-->
  <router-view />
</template>
<script>
export default {
  name: "AccountIndex"
};
</script>
<style lang="less" scoped></style>
